// Vue
import Vue from 'vue';

// disable dev alert
Vue.config.productionTip = false

// global objects
Vue.prototype.$window = window;

// axios and httpError
import axios from 'axios';
window.axios = require('axios');
import httpError from "../plugins/http.error.js";
Vue.use(httpError);


// cloud start
import cloudWebWrapper from '../../components/cloud/cloud.web.wrapper.vue';
if(document.getElementById("app")) {
    new Vue({
    	el : '#app',
    	components: { cloudWebWrapper }
    });
}
